import { Component, h } from "@stencil/core";

@Component({
  tag: "lod-processing-register-result-skeleton",
  shadow: false,
})

/**
 * @internal
 */
export class LodProcessingRegisterResultSkeleton {
  render() {
    return (
      <div class="">
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
        <div class="teaser teaser--wide">
          <div class="skeleton skeleton-h3-long"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-medium"></div>
          <div class="skeleton skeleton-h3"></div>
          <div class="skeleton skeleton-h3-short"></div>
        </div>
      </div>
    );
  }
}
